export default {
  title: 'เรียกวิน',
  fare_board_title: 'ราคาวิน',
  fare_board_not_set: 'ยังไม่ได้ตั้งราคาวิน',
  request_button: 'เรียกวิน',
  cancel_button: 'ยกเลิกการเรียกวิน',
  status: {
    pending: 'กำลังรอวิน...',
    accepted: 'มีวินรับงานแล้ว ✅',
    expired: 'ยังไม่มีวินรับงาน',
    cancelled: 'ยกเลิกการเรียกวินแล้ว',
  },
  poll_note: 'ระบบจะแจ้งเตือนเมื่อมีวินรับงาน คำขอจะหมดอายุหลังจาก 10 นาที',
  module_disabled: 'บริการวินไม่พร้อมใช้งานในขณะนี้',
  errors: {
    create_failed: 'ไม่สามารถส่งคำขอได้ กรุณาลองอีกครั้ง',
    already_pending: 'คุณมีคำขอที่รอดำเนินการอยู่แล้ว',
    cancel_failed: 'ไม่สามารถยกเลิกคำขอได้ กรุณาลองอีกครั้ง',
    load_failed: 'ไม่สามารถโหลดราคาวินได้',
    no_active_lease: 'ไม่พบสัญญาเช่าที่ใช้งานอยู่สำหรับห้องนี้',
  },
}
